























import Vue, { VueConstructor } from "vue";
import { Note } from "../../services/vo";
export default (Vue as VueConstructor<
  Vue & {
    $refs: {
      notearea: HTMLTextAreaElement;
    };
  }
>).extend({
  props: {
    note: {
      type: Object as () => Note,
      default: new Note()
    },
    index: {
      type: Number,
      default: 0
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pNote: new Note(),
      removing: false
    }
  },
  created() {
    this.pNote = this.note;
  },
  mounted() {
    this.resizeTextarea();
    if (this.readonly) {
      this.$refs.notearea.style.resize = "none";
    }
  },
  methods: {
    deleteNote: function(): void {
      this.removing = true;
      this.$emit("delete-note", this.index);
    },
    resizeTextarea: function(): void {
      let el = this.$refs.notearea;
      el.style.height = "auto";
      el.style.height = this.$refs.notearea.scrollHeight + "px";
    }
  }
});
